'use strict';

import ReactDOM from 'react-dom';
import React from 'react';

// Plugins
import $ from 'jquery';
import 'bootstrap';

window.$ = window.jQuery = $;

// Utils
import matchJS from './utils/matchJS';
import { initReact } from './utils/initReact';

// Routes
import common from './routes/common';
import appIndex from './routes/app';
import appAccessCode from './routes/app/accessCode';
import registerShowRegistrationForm from './routes/register/showRegistrationForm';
import profilesState from './routes/profiles/state';
import profilesCover from './routes/profiles/cover';
import profilesRede from './routes/profiles/rede';
import profilesQuestions from './routes/profiles/questions';
import profilesPassword from './routes/profiles/password';
import challenges from './routes/challenges/common';
import challengesIndex from './routes/challenges/';
import challengesCreate from './routes/challenges/create';
import challengesEdit from './routes/challenges/edit';
import challengesShow from './routes/challenges/show';
import challengesGallery from './routes/challenges/gallery';
import challengesMaterials from './routes/challenges/materials';
import { challengesMine } from './routes/challenges/mine';
import presences from './routes/presences/common';
import presencesIndex from './routes/presences/';
import presencesActivities from './routes/presences/activities';
import presencesGallery from './routes/presences/gallery';
import presencesParticipants from './routes/presences/participants';
import presencesSavedReport from './routes/presences/savedReport';
import reportActivities from './routes/reportactivities';
import faqs from './routes/faqs/common';
import forgotpassword from './routes/forgotpassword/common';
import showResetForm from './routes/resetpassword/showResetForm';
import { showLoginForm } from './routes/login/showLoginForm';
import { profilePersonal } from './routes/profiles/personal';
import subscribesShow from './routes/subscribes/show';
import { hours } from './routes/presences/hours';
import { benefiteds } from './routes/presences/benefiteds';

// React
import Materials from './routes/materials';
import Comments from './react/components/comments';

var APP = {
  common: {
    init() {
      common.init();
    },
  },

  app: {
    index() {
      appIndex.init();
    },

    accessCode() {
      appAccessCode.init();
    },
  },

  login: {
    showLoginForm() {
      showLoginForm();
    },
  },

  register: {
    showRegistrationForm() {
      registerShowRegistrationForm.init();
    },
  },

  resetpassword: {
    showResetForm() {
      showResetForm.init();
    },
  },

  profiles: {
    personal() {
      profilePersonal();
    },

    state() {
      profilesState.init();
    },

    cover() {
      profilesCover.init();
    },

    rede() {
      profilesRede.init();
    },

    questions() {
      profilesQuestions.init();
    },

    password() {
      profilesPassword.init();
    },
  },

  challenges: {
    init() {
      challenges.init();
    },

    index() {
      challengesIndex.init();
    },

    search() {
      challengesIndex.init();
    },

    create() {
      challengesCreate.init();
    },

    edit() {
      challengesEdit.init();
    },

    show() {
      challengesShow.init();
      initReact(document.getElementById('comments'), Comments);
    },

    gallery() {
      challengesGallery.init();
    },

    materials() {
      challengesMaterials.init();
    },
    mine() {
      challengesMine();
    },
  },

  subscribes: {
    show() {
      subscribesShow.init();
    },
  },

  presences: {
    init() {
      presences.init();
    },

    index() {
      presencesIndex.init();
    },

    activities() {
      presencesActivities.init();
    },

    gallery() {
      presencesGallery.init();
    },

    participants() {
      presencesParticipants.init();
    },

    savedreport() {
      presencesSavedReport.init();
    },

    hours() {
      hours();
    },

    benefiteds() {
      benefiteds();
    },
  },

  faqs: {
    init() {
      faqs.init();
    },
  },

  forgotpassword: {
    init() {
      forgotpassword.init();
    },
  },
  materials: {
    index() {
      ReactDOM.render(<Materials />, document.getElementById('app'));
    },
  },
  reportactivities: {
    index() {
      reportActivities.init();
    },
  },
};

$(document).ready(matchJS.init(APP));
